import { ProductFilter } from '../../../models/Product';
import Base64 from './base64';
import mapValues from 'lodash/mapValues';
import { log } from './log';
import { FilterSetting } from '../../store/api';

export function deserializeFilter(
    filter: string | undefined,
    options: {
        includeKey: keyof FilterSetting;
        excludeKey: keyof FilterSetting;
    } = {
        includeKey: 'includeFilterValues',
        excludeKey: 'excludeFilterValues'
    }
): ProductFilter {
    if (!filter) {
        return {};
    }

    try {
        const parsed = JSON.parse(Base64.decode(filter));

        return mapValues(parsed, filterSetting => ({
            [options.includeKey]: filterSetting.include ?? [],
            [options.excludeKey]: filterSetting.exclude ?? []
        }));
    } catch (e) {
        log.info('Cannot parse query filters', { filter });
        return {};
    }
}
